<template lang='pug'>
  .product-details(v-if='product && product.attributes')
    router-link.row.product-card.product-reviews-card(:to='{ name: "products-show", id: product.attributes["slug-url"] }')
      .col-4
        img.product-card-image(:src='product.attributes["closeup-image-urls"][0]')
      .col-8
        .product-card-description.product-reviews-description
          p.product-card-label(v-if='product.attributes["new-arrival"]')
            span.product-card-label-primary(v-text='$t("common.new")')
          p.product-brand(v-if='currentVariant && currentVariant.attributes' v-text='currentVariant.attributes["brand-name"]')
          p.product-name(v-text='product.attributes["name"]')
          p.product-heading(v-if='product.attributes["heading"] && product.attributes["heading"].length > 0' v-text='product.attributes["heading"]')
          product-price(:variant='currentVariant')

    a.btn.btn-block.write-review-btn(v-if='!bvHostedUiEnabled' :href='"/account/reviews"' v-text='$t("products.reviews.write")')
    .clearfix
</template>

<script>
import { mapState } from 'vuex'
import ProductPrice from '../product-price.vue'

export default {
  components: {
    ProductPrice
  },

  computed: {
    ...mapState({
      product: state => state.product.product,
      currentVariant: state => state.product.currentVariant
    }),

    bvHostedUiEnabled: () => vueSupport?.featureFlags?.enableBvHostedUi
  }
}
</script>

<style scoped lang='scss'>
  %description {
    line-height: 21px;
    margin-bottom: 3px;
  }

  .product-details {
    padding-bottom: 25px;
    border-bottom: 1px solid $grey;
  }

  .product-reviews-card {
    margin-bottom: 20px;
  }

  .product-reviews-description {
    margin: 0 !important;
    font-size: 16px;

    .product-brand {
      @extend %description;
      @include font-weight-bold;
      text-transform: uppercase;
    }

    .product-name {
      @extend %description;
    }

    .product-heading {
      margin-bottom: 6px;
    }
  }
</style>
